import { getTemplate } from '../utilities'
import { SupafolioLookupCarousel } from './SupafolioLookupCarousel.js'

export class AuthorDetails {
  constructor (client, contributorID) {
    this.client = client
    this.contributorID = contributorID
    this.authorBooksObjectIds = []
  }

  /**
     * @returns {*}
     */
  async run () {
    try {
      this.client.addDetailsWidget({
        objectID: `${this.contributorID}`,
        source: 'contributors',
        container: '#contributor-details',
        resultHandler: this.contributorResultHandler.bind(this),
        static: {
          contributors: true
        },
        templates: {
          item: getTemplate('contributor-details'),
          empty: getTemplate('no-results')
        }
      }).then(() => {
        addEventListeners()
      })
    } catch (err) {
      console.log(err)
    }
  }

  checkFeaturedAuthor () {
    if (!document.getElementById('contributor-details').getAttribute('contributorid')) {
      return false
    }
    return true
  }

  readMoreLink (author, readMoreCopy = 'Read More') {
    if (!author.contributor_id) {
      return ''
    }
    return `<a href="/collections/vendors?q=${author.name}:::${author.contributor_id}&contributorID=${author.contributor_id}" title="${author.name}">${readMoreCopy}</a>`
  }

  getAssets (author) {
    if (author.assets === null || author.assets.length === 0) {
      return ''
    }
    const authorName = author.name
    const assets = []
    author.assets.forEach((asset) => {
      const type = asset.asset.sub_type
      if (type === 'author-website') {
        assets.push(`<p><a href="${asset.asset.path}" target="_blank" title="${authorName} - Official site">Official site</a></p>`)
      } else if (type === 'author-blog') {
        assets.push(`<p><a href="${asset.asset.path}" target="_blank" title="${authorName} - Blog">Blog</a></p>`)
      } else if (type === 'author-twitter') {
        assets.push(`<p><a href="https://www.${asset.asset.path}" target="_blank" title="${authorName} - X">X</a></p>`)
      } else if (type === 'author-facebook') {
        assets.push(`<p><a href="${asset.asset.path}" target="_blank" title="${authorName}' - Facebook">Facebook</a></p>`)
      }
    })

    return assets
  }

  contributorResultHandler (author) {
    const templateVars = {}
    if (this.checkFeaturedAuthor() === false) {
      templateVars.otherLinks = this.getAssets(author)
    } else {
      const featuredAuthorBooks = document.querySelector('.supafolio-featured-author .js-supafolio-book-carousel-section')
      templateVars.featuredAuthorTitle = this.readMoreLink(author, author.name)
      templateVars.featuredAuthorReadMore = this.readMoreLink(author)
      if (author.bio) {
        author.bio = author.bio.split(' ').splice(0, 65).join(' ') + '...'
      }
      if (!author.books) {
        return ''
      }
      this.authorBooksObjectIds = author.books.map(product => product.isbn13).slice(0, 3)
      SupafolioLookupCarousel.initCarousel(this.client, featuredAuthorBooks, this.authorBooksObjectIds, 3)
    }
    author.templateVars = templateVars
    this.author = author
    return author
  }
}

function addEventListeners () {
  if (document.getElementById('contributor-details') !== null) {
    document.getElementById('contributor-details').style.display = 'block'
  }
}
